var React = require('react');

function IconVirtualMeeting (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.674 2.222H1.66A1.66 1.66 0 0 0 0 3.882v10.014c0 .916.743 1.66 1.66 1.66h10.014a1.66 1.66 0 0 0 1.66-1.66V3.882a1.66 1.66 0 0 0-1.66-1.66Zm6.576 1.31-3.806 2.624v5.465l3.806 2.622c.736.507 1.75-.01 1.75-.896v-8.92c0-.882-1.01-1.403-1.75-.896Z"}));
}

IconVirtualMeeting.defaultProps = {"fill":"currentColor","viewBox":"0 0 20 18"};

module.exports = IconVirtualMeeting;

IconVirtualMeeting.default = IconVirtualMeeting;
